import { render, staticRenderFns } from "./PccDeposits.vue?vue&type=template&id=5a2514ed&scoped=true&"
import script from "./PccDeposits.vue?vue&type=script&lang=ts&"
export * from "./PccDeposits.vue?vue&type=script&lang=ts&"
import style0 from "./PccDeposits.vue?vue&type=style&index=0&id=5a2514ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2514ed",
  null
  
)

export default component.exports